// Build-time mirrors of the API's operator kill switches.
//
// The API is always the enforcement authority — it 403s with a stable code on
// the closed path. These flags only hide the matching UI so nobody is walked
// into an endpoint that can only refuse them.
//
// Fails OPEN: a capability is closed ONLY on the exact string "false", so a
// typo or an unset var can never take a feature down. This mirrors the API's
// `getEnvKillSwitch` in api/src/config/index.ts — keep the two in step.
const ENV = import.meta.env as Record<string, string | undefined>;

export function envSwitch(name: string): boolean {
  return ENV[name] !== 'false';
}
